/**
 * Shared per-user color hashing, used for both the request UserBadge pill
 * and the chat Avatar circle — so the same user always gets the same color
 * across every part of the app.
 */

export interface AvatarColorPair {
  bg: string;
  text: string;
}

export interface AvatarPalette {
  dark: AvatarColorPair;
  light: AvatarColorPair;
}

export const AVATAR_COLOR_PALETTE: AvatarPalette[] = [
  { dark: { bg: 'rgba(59,130,246,0.3)', text: '#93c5fd' }, light: { bg: '#dbeafe', text: '#1d4ed8' } },
  { dark: { bg: 'rgba(16,185,129,0.3)', text: '#6ee7b7' }, light: { bg: '#d1fae5', text: '#047857' } },
  { dark: { bg: 'rgba(168,85,247,0.3)', text: '#d8b4fe' }, light: { bg: '#ede9fe', text: '#6d28d9' } },
  { dark: { bg: 'rgba(245,158,11,0.3)', text: '#fcd34d' }, light: { bg: '#fef3c7', text: '#b45309' } },
  { dark: { bg: 'rgba(236,72,153,0.3)', text: '#f9a8d4' }, light: { bg: '#fce7f3', text: '#be185d' } },
  { dark: { bg: 'rgba(20,184,166,0.3)', text: '#5eead4' }, light: { bg: '#ccfbf1', text: '#0f766e' } },
  { dark: { bg: 'rgba(249,115,22,0.3)', text: '#fdba74' }, light: { bg: '#ffedd5', text: '#c2410c' } },
  { dark: { bg: 'rgba(99,102,241,0.3)', text: '#a5b4fc' }, light: { bg: '#e0e7ff', text: '#4338ca' } },
];

export function hashUserId(userId: string): number {
  let h = 0;
  for (let i = 0; i < userId.length; i++) {
    h = ((h << 5) - h + userId.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function avatarColorFor(userId: string, isDark: boolean): AvatarColorPair {
  const palette = AVATAR_COLOR_PALETTE[hashUserId(userId) % AVATAR_COLOR_PALETTE.length];
  return isDark ? palette.dark : palette.light;
}
